import React from 'react';
import { useLocation } from 'react-router-dom';
import Picture from '@/image/hotel/magazine_bottom.jpg';

export const Magazine = () => {
  // URL の先頭セグメントを取得し、'en' なら英語、それ以外は日本語とする
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const language = langSegment === 'en' ? 'en' : 'ja';

  return (
    <div className="max-md:container max-md:mx-auto">
      <p className="text-center text-lg">Our Magazine</p>

      <div className="border-t border-black mt-4">
        {/* フレックスコンテナを追加 */}
        <div className="flex flex-col md:flex-row">
          {/* 画像 */}
          <img
            src={Picture}
            alt="Sample"
            className="w-full md:w-1/2 object-cover my-4"
          />

          {/* テキストを中央に配置 */}
          <div className="flex items-center justify-center w-full md:w-1/2 mb-16">
            {language === 'en' ? (
              <p className="text-center mt-4 mb-3 md:mb-0 md:max-w-[380px]">
                Hands-on exploration of the neighborhood. Discover the stories
                that make up our neighborhood.
              </p>
            ) : (
              <p className="text-center mt-4 mb-3 md:mb-0 md:max-w-[380px]">
                ザ・アパートメントホテルの部屋に泊まると、プリント版のガイドブックを手に入れることができる。
                滞在中の最も贅沢な過ごし方は、ガイドブックをトートバッグに投げ込み、
                東京の厳選されたネイバーフッドを自由気ままに歩いて探索すること。
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
